import React, { useEffect } from "react"
import { useEventBus } from "./provider"

export function Console() {

  const bus = useEventBus()

  useEffect(() => {
    window.cirrus = {
      ...window.cirrus,
      events: {
        send: (event: string, payload: any) => {
          bus.emit(event, payload)
        },
      }
    }
  }, [])

  return null
}
